import { getToken } from '../auth/tokenStore';
import { ApiError, Client } from '../common/types';
import { apiBaseUrl } from '../index';

// Create a new client
export const createClient = async (
  name: string,
  firstName: string,
  lastName: string
): Promise<Client> => {
  const accessToken: string = await getToken();
  const response = await fetch(`${apiBaseUrl}/clients`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    },
    body: JSON.stringify({ name: name, firstName, lastName })
  });

  if (!response.ok) {
    throw new Error(`${await response.text()}`);
  }

  return response.json();
};

// Retrieve all clients for the current user
export const getClients = async (): Promise<Client[]> => {
  const accessToken: string = await getToken();
  const response = await fetch(`${apiBaseUrl}/clients`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    }
  });

  if (!response.ok) {
    throw new Error(`${await response.text()}`);
  }

  return await response.json();
};

// Retrieve single client by id
export const getClientById = async (clientId: number): Promise<Client> => {
  const accessToken: string = await getToken();
  const response = await fetch(`${apiBaseUrl}/clients/${clientId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    }
  });

  if (!response.ok) {
    throw new ApiError(await response.text(), response.status);
  }

  return await response.json();
};

export const updateClient = async (
  clientId: number,
  firstName?: string,
  lastName?: string
): Promise<Client> => {
  const accessToken: string = await getToken();
  const response = await fetch(`${apiBaseUrl}/clients/${clientId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    },
    body: JSON.stringify({ firstName, lastName })
  });
  if (!response.ok) {
    throw new Error(`${await response.text()}`);
  }
  return response.json();
};

export const deleteClientById = async (clientId: number) => {
  const response = await fetch(`${apiBaseUrl}/clients/${clientId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${await getToken()}`
    }
  });

  if (!response.ok) {
    throw new Error(`${await response.text()}`);
  }

  return true;
};
